import * as React from 'react';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import { ApiService } from '../../../services/api_service';
import { DataService } from '../../../services/data_service';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { b64ToBlob } from '../../../core/elements/helper/b64ToBlob';
import * as Moment from 'moment';

export interface ToolExportImportState {
    showSpinner: boolean;
    showDialog: string;
    importFile: any;
    importBereich: string;
    bereiche: Array<any>,
}

export class ToolExportImport extends React.Component<{}, ToolExportImportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showSpinner: false,
            showDialog: null,
            importFile: null,
            importBereich: undefined,
            bereiche: null
        };

        this.uploadTool = this.uploadTool.bind(this);
        this.exportTool = this.exportTool.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.loadData();
    }

    loadData() {
        this.dataService.loadData(IDs.ENT_BRANCHEN_BEREICHE, null, null, (res: any) => {
            if (res && Array.isArray(res[IDs.ENT_BRANCHEN_BEREICHE])) {
                this.setState({ bereiche: res[IDs.ENT_BRANCHEN_BEREICHE] });
            }
        }, IDs.MOD_ETOOL_ADMIN);
    }

    render(): JSX.Element {
        return <div style={{ display: 'flex', flexDirection: 'row' }}>
            <WActionButton
                label='Import'
                insideText='Import'
                tooltip='Import'
                key='import'
                action='import'
                onAction={() => this.setState({ showDialog: 'import' })}
            />
            <WActionButton
                label='Export'
                insideText='Export'
                tooltip='Export'
                key='export'
                action='export'
                onAction={() => this.setState({ showDialog: 'export' })}
            />
            {this.state.showDialog === 'import' && this.renderDlgImport()}
            {this.state.showDialog === 'export' && this.renderDlgExport()}
            {this.state.showSpinner && <WSpinner />}
        </div>
    }

    renderDlgImport(): JSX.Element {
        const filename = (this.state.importFile || {}).name;
        return <div>
            <DialogWrapper2
                left={10}
                title='Tool-Import'
                onAfterClose={() => this.setState({ showDialog: null, importFile: null, importBereich: undefined })}
            >
                <div style={{ padding: 10, width: 600, display: 'flex', flexDirection: 'column', fontSize: 14 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                        <div style={{ width: 400, padding: 5, marginRight: 5 }}>
                            Das Tool wird in diesen Bereich importiert werden:
                        </div>
                        <select
                            style={{ padding: 5, width: 130 }}
                            value={this.state.importBereich}
                            onChange={(e) => this.setState({ importBereich: e.target.value })}
                        >
                            <option value={undefined}>Keine Auswahl</option>
                            {this.state.bereiche.map((r: any, i: number) =>
                                <option key={`option_bereiche_${i}`} value={r.intern_key}>{r.name}</option>)}
                        </select>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                        <div style={{ width: 400, backgroundColor: 'lightgray', padding: 5, marginRight: 5, ...(filename ? { fontWeight: 'bold' } : { fontStyle: 'italic' }) }}>
                            {filename || 'Keine Datei'}
                        </div>
                        <button style={{ padding: 5, width: 130 }}>
                            <label
                                htmlFor={'fileUploaderToolImport'}
                                style={{ cursor: 'pointer' }}
                            >
                                Zip-Datei wählen
                            </label>
                        </button>
                        <input
                            style={{ width: 0, height: 0 }}
                            type='file'
                            onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                    const file = e.target.files[0];
                                    if (this.dataService.fileSizeCheck && file.size >= this.dataService.fileSizeLimit) {
                                        alert('Bitte verwenden Sie nur Dateien mit einer maximalen Größe von ' + this.dataService.fileSizeInfo);
                                    } else {
                                        this.setState({ importFile: file });
                                    }
                                }
                            }}
                            id={'fileUploaderToolImport'}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 50 }}>
                        <button
                            style={{ padding: 5, width: 130 }}
                            onClick={this.uploadTool}
                            disabled={!this.state.importFile || !this.state.importBereich}
                        >
                            Tool importieren
                        </button>
                    </div>
                </div>
                {this.state.showSpinner && <WSpinner />}
            </DialogWrapper2>
        </div >;
    }

    renderDlgExport(): JSX.Element {
        const struct_tool = new StructureTool(IDs.MOD_ETOOL_ADMIN);
        const strucRegi = struct_tool.getStructure(IDs.MOD_ETOOL_ADMIN, IDs.ENT_REGISTRIERUNG);
        const showColums = ['unternehmen', 'bereich_key', 'mail', 'datum_bearbeitung', 'test_registrierung'];
        const hiddenColumns = strucRegi && Array.isArray(strucRegi.ATTS) ? strucRegi.ATTS.filter((att: any) => showColums.indexOf(att.KEY) === -1).map((att: any) => att.KEY) : [];
        return <div>
            <DialogWrapper2
                left={10}
                title='Tool-Export'
                onAfterClose={() => this.setState({ showDialog: null })}
            >
                <div style={{ padding: 10 }}>
                    <WFormsTableWrapper
                        entity={IDs.ENT_REGISTRIERUNG}
                        module={IDs.MOD_ETOOL_ADMIN}
                        actions={[]}
                        customClass='Custom-ETA'
                        formLayout='flowV2'
                        preFilterServer={{ mail_confirmed: 1, active: 1 }}
                        hiddenColumns={hiddenColumns}
                        tablePageSize={10}
                        columnWidths={[300, 100, 300, 100, 100]}
                        showTableHelp={false}
                        customActions={[{
                            key: 'export',
                            func: this.exportTool,
                            info: 'Daten exportieren'
                        }]}
                    />
                </div>
                {this.state.showSpinner && <WSpinner />}
            </DialogWrapper2>
        </div>;
    }

    exportTool(regi: any) {
        this.setState({ showSpinner: true }, () => {
            this.apiService.call('exportTool', { regiTid: regi.tid }, (json: string, succ: boolean) => {
                if (succ) {
                    let obj;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) {
                        console.error(e, json);
                    }
                    if (obj) {
                        console.log(obj.meta);
                        b64ToBlob(obj.zip, 'application/octet-stream', (blob: any) => {
                            const filename = `Export_${regi.unternehmen}_${Moment().format('YYYY-MM-DD')}.zip`;
                            saveAs(blob, filename);
                        });
                    }
                }
                this.setState({ showSpinner: false });
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    uploadTool() {
        console.log(this.state.importBereich, this.state.importFile);
        const reader = new FileReader();
        const that = this;
        reader.onload = function (event: any) {
            that.setState({ showSpinner: true }, () => {
                that.apiService.call('uploadTool', {
                    name: that.state.importFile.name,
                    bereich: that.state.importBereich,
                    data: event.target.result
                }, (json: string, succ: boolean) => {
                    if (succ) {
                        let obj;
                        try {
                            obj = JSON.parse(json);
                        } catch (e) {
                            console.error(e, json);
                        }
                        if (obj) {
                            console.log(obj);
                            if (obj.status === 0) {
                                alert(obj.message);
                            } else if (obj.status === 1 || obj.status === 2) {
                                if (window.confirm(obj.message)) {
                                    that.importTool(obj);
                                }
                            }
                        }
                    } else {
                        alert('Import fehlgeschlagen!');
                    }
                    that.setState({ showSpinner: false });
                }, IDs.MOD_ETOOL_ADMIN);
            });

        };
        reader.readAsDataURL(this.state.importFile);
    }

    importTool(params: any) {
        this.setState({ showSpinner: true }, () => {
            this.apiService.call('importTool', { bereich: this.state.importBereich, stamp: params.stamp }, (json: string, succ: boolean) => {
                console.log(json);
                this.setState({ showSpinner: false });
                alert('Das Tool wurde erfolgreich importiert. Eine Log-Datei wird erstellt.');
                const blob = new Blob([json], { type: "text/plain;charset=utf-8" });
                const filename = `log_${this.state.importBereich}_${params.stamp}_${Moment().format('YYYY-MM-DD')}.json`;
                saveAs(blob, filename);
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }
}
